import { configureStore } from '@reduxjs/toolkit';
import createReducer from './rootReducer';

if (import.meta.env.DEV && import.meta.hot) {
	import.meta.hot.accept('./rootReducer', async () => {
		const { default: newCreateReducer } = await import('./rootReducer');
		store.replaceReducer(newCreateReducer(store.asyncReducers));
	});
}

const middlewares = [];

if (import.meta.env.DEV) {
	const { createLogger } = await import('redux-logger');
	const logger = createLogger({ collapsed: (getState, action, logEntry) => !logEntry.error });

	middlewares.push(logger);
}

const store = configureStore({
	reducer: createReducer(),
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false
		}).concat(middlewares),
	devTools: import.meta.env.DEV
});

store.asyncReducers = {};

// Registra un reducer asíncrono una sola vez (los repetidos se ignoran).
export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(createReducer(store.asyncReducers));
};

export default store;
